import { render, staticRenderFns } from "./popUp.vue?vue&type=template&id=23964232&scoped=true&"
import script from "./popUp.vue?vue&type=script&lang=js&"
export * from "./popUp.vue?vue&type=script&lang=js&"
import style0 from "./popUp.vue?vue&type=style&index=0&id=23964232&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23964232",
  null
  
)

export default component.exports